import React from 'react';
import { InvestorSex, PortfolioDetailsInvestorItem } from '../../../../models/Portfolio';
import { Box, ITheme, Typography, useTheme } from '@mui/material';
import { Utilities } from '../../../../utility/utils';
import { useTranslation } from 'react-i18next';

export interface IInvestorsSexGraphProps {
    investors: PortfolioDetailsInvestorItem[];
}

const renderLabel = (pos: number[], proportion: number, textColor: string, backgroundColor: string): React.ReactNode => {
    return <foreignObject width={"60px"} height={"30px"} x={pos[0] - 30} y={pos[1] - 15}>
        <Box width={"100%"} height={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box display={"flex"} padding={"1px 2px"} bgcolor={backgroundColor} borderRadius={"10px"} justifyContent={"center"} alignItems={"center"}>
                <Typography fontSize={"12px"} fontWeight={"500"} lineHeight={"14.63px"} color={textColor}>{Math.round(100 * proportion)}%</Typography>
            </Box>
        </Box>
    </foreignObject>
}
const InvestorsSexGraph: React.FC<IInvestorsSexGraphProps> = ({ investors }) =>{
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    const colors = Utilities.shuffleArray(Object.keys(theme.palette.leo).filter(k => k.indexOf("color")!== -1).map(k => (theme.palette.leo as any)[k]));
    const width = 150;
    const height = 100;
    const radius = 55;
    const strokeWidth = 30;
    const total = investors.length;
    const male:number = investors.filter(i => i.sex === InvestorSex.Male).length;
    const female = investors.filter(i => i.sex === InvestorSex.Female).length;
    const other = total - male - female;
    return <Box display={"flex"} flexDirection={"column"} gap={"13px"} flexGrow={1} flexBasis={"100px"}>
        <Typography>{t('PortfolioDetailsInvestorsDemographicSplitSex')}</Typography>
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <g transform={`translate(${width/2}, ${height-20})`}>
                <path d={Utilities.f_svg_ellipse_arc([0, 0], [radius, radius], [0, Math.PI * (male / total)], Math.PI)} stroke={colors[0]} strokeLinecap="butt" strokeWidth={strokeWidth} fill="none" />
                <path d={Utilities.f_svg_ellipse_arc([0, 0], [radius, radius], [Math.PI * (male / total), Math.PI * (female / total)], Math.PI)} stroke={colors[1]} strokeLinecap="butt" strokeWidth={strokeWidth} fill="none" />
                <path d={Utilities.f_svg_ellipse_arc([0, 0], [radius, radius], [Math.PI * ((male+female) / total), Math.PI * (other / total)], Math.PI)} stroke={colors[2]} strokeLinecap="butt" strokeWidth={strokeWidth} fill="none" />
                {(male / total) > 0.05 && renderLabel(Utilities.f_svg_rotate_coord([radius, 0], Math.PI + Math.PI * (male / total) /2), male/total, colors[0], theme.palette.background.paper)}
                {(female / total) > 0.05 && renderLabel(Utilities.f_svg_rotate_coord([radius, 0], Math.PI + Math.PI * ((male + female/2) / total) ), female/total, colors[1], theme.palette.background.paper)}
                {(other / total) > 0.05 && renderLabel(Utilities.f_svg_rotate_coord([radius, 0], Math.PI + Math.PI * ((male + female + other/2) / total)), other/total, colors[2], theme.palette.background.paper)}
            </g>
        </svg>
        <Box display={"flex"} gap={"13px"} alignItems={"center"}>
            <Box width={"14px"} height={"14px"} bgcolor={colors[0]} borderRadius={"10px"}></Box>
            <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"600"} color={theme.palette.leo.tone3}>{t('PortfolioDetailsInvestorsDemographicSplitSexMale')}</Typography>
        </Box>
        <Box display={"flex"} gap={"13px"} alignItems={"center"}>
            <Box width={"14px"} height={"14px"} bgcolor={colors[1]} borderRadius={"10px"}></Box>
            <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"600"} color={theme.palette.leo.tone3}>{t('PortfolioDetailsInvestorsDemographicSplitSexFemale')}</Typography>
        </Box>
        <Box display={"flex"} gap={"13px"} alignItems={"center"}>
            <Box width={"14px"} height={"14px"} bgcolor={colors[2]} borderRadius={"10px"}></Box>
            <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"600"} color={theme.palette.leo.tone3}>{t('PortfolioDetailsInvestorsDemographicSplitSexOther')}</Typography>
        </Box>
    </Box>;
}

export default InvestorsSexGraph;